import { render, staticRenderFns } from "./PdfRenderer.vue?vue&type=template&id=33f1f600&lang=pug"
import script from "./PdfRenderer.vue?vue&type=script&lang=js"
export * from "./PdfRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports